var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVnFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16011_68504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0008 40.0001C31.046 40.0001 39.9999 31.0461 39.9999 20.0009C39.9999 8.95574 31.046 0.00183105 20.0008 0.00183105C8.95562 0.00183105 0.00170898 8.95574 0.00170898 20.0009C0.00170898 31.0461 8.95562 40.0001 20.0008 40.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8568 13.3317C38.8546 13.3254 38.8527 13.32 38.8505 13.3143C36.2908 6.09713 29.7069 0.787138 21.7964 0.0822754C24.8573 1.76037 25.7513 7.07703 26.5345 13.3318C27.0695 17.6041 27.0729 22.3116 26.5446 26.5892C25.7681 32.8778 24.8704 38.232 21.7965 39.9171C29.7215 39.211 36.3149 33.8827 38.8645 26.6461C38.8712 26.6268 38.8768 26.6079 38.8838 26.5892C39.6037 24.5256 40 22.3094 40 20.0003C39.9997 17.6609 39.5945 15.4176 38.8568 13.3317Z",
    fill: "#E12A28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5639 13.3317C26.7811 7.07683 24.8572 1.76026 21.796 0.082165C21.2039 0.0297246 20.6052 0 19.9995 0C11.2993 0 3.90035 5.55674 1.14913 13.3143C1.14693 13.3199 1.14499 13.3253 1.14279 13.3317C0.405167 15.4175 0 17.6609 0 20.0001C0 22.3095 0.3963 24.5254 1.11628 26.589C1.12295 26.6077 1.12895 26.6266 1.13553 26.6459C3.87594 34.4234 11.285 39.9996 19.9995 39.9996C20.6052 39.9996 21.2039 39.9699 21.7959 39.9168C24.8698 38.2318 26.7974 32.8776 27.5739 26.5889C28.1023 22.3111 28.0988 17.604 27.5639 13.3317Z",
    fill: "#ED3432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8207 9.74951L22.1964 17.0619H29.8855L23.6648 21.5803L26.0407 28.8935L19.8207 24.3739L13.6003 28.8935L15.9763 21.5803L9.75586 17.0619H17.4447L19.8207 9.74951Z",
    fill: "#FDCE0C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16011_68504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVnFlag);
export default __webpack_public_path__ + "static/media/vn_flag.1d2955bf62a2bf9940be929734943174.svg";
export { ForwardRef as ReactComponent };